import axios from '~/common/plugins/axios.js'
export const state = () => ({
  data: [],
  pagination: {
    listName: "商户管理",
    total: 0,
    current: 1,
    page_size: 15,
  },
  options: [],
  operateData: [],
  operateIndex: -1,
  editState:false,
})

export const mutations = {
  setData(state, data) {
    state.data = data
  },
  setDataCount(state, data) {
    state.pagination.total = data
  },
  setOperateData(state, data) {
    state.operateData = data
  },
  setOperateIndex(state, data) {
    state.operateIndex = data
  },
  setPagination(state, data) {
    state.pagination.current = data.current
  },
  setOptions(state, data) {
    state.options = data
  },
  setEditState(state, data) {
    state.editState = data
  },
}

export const actions = {
  async getData({ dispatch, commit }, parameter) {
    const { data: { list, pagination } } = await axios.$post('/rest/erp/contact/v3/contactshopsbacklist', parameter);
    commit('setData', list);
    if (pagination && pagination.total) {
      if (Math.ceil(pagination.total / pagination.page_size) < pagination.current) {
        parameter.current = 1;
        dispatch('getData', { parameter })
      }
      commit('setDataCount', pagination.total);
    } else {
      commit('setDataCount', 0);
    }
    return { list, pagination };
  },
  async getInfo({ commit }, parameter) {
    const data = await axios.$get(`/rest/erp/contact/v3/contactshop/${parameter.id}`);
    return data;
  },
  async add({ commit }, parameter) {
    const data = await axios.$post("/rest/erp/contact/v3/contactshop", parameter);
    return data;
  },
  async edit({ commit }, parameter) {
    const data = await axios.$put('/rest/erp/contact/v3/contactshop', parameter);
    return data;
  },
  async del({ commit }, parameter) {
    const data = await axios.$delete(`/rest/erp/contact/v3/contactshop/${parameter.id}`);
    return data;
  },
  async getMembers({ commit }, parameter) {
    const data = await axios.$post('/rest/erp/contact/v3/contactshopmembersidnamelist', parameter);
    return data;
  },
  async getMemberInfo({ commit }, parameter) {
    const data = await axios.$get(`/rest/erp/contact/v3/contactshopmember/${parameter.id}`);
    return data;
  },
  async addMember({ commit }, parameter) {
    const data = await axios.$post('/rest/erp/contact/v3/contactshopmember', parameter);
    return data;
  },
  async editMember({ commit }, parameter) {
    const data = await axios.$put('/rest/erp/contact/v3/contactshopmember', parameter);
    return data;
  },
  async delMember({ commit }, parameter) {
    const data = await axios.$delete(`/rest/erp/contact/v3/contactshopmember/${parameter.id}`);
    return data;
  },
  async getContacts({ commit }, parameter) {
    const data = await axios.$post('/rest/erp/contact/v3/contactuser/query', parameter);
    return data;
  },
  updateOperateData({ commit }, parameter) {
    commit('setOperateData', parameter)
  },
  updatePagination({ commit }, parameter) {
    commit('setPagination', parameter)
  },
  updateOptions({ commit }, parameter) {
    commit('setOptions', parameter)
  },
  updateOperateIndex({ commit }, parameter) {
    commit('setOperateIndex', parameter)
  },
  updateEditStatus({ commit }, parameter){
    commit('setEditState', parameter)
  }
}
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
